import { isString, isNumber, toNumber } from 'lodash'

const CURRENCY_MARK = {
    USD: '$',
    CAD: 'CAD $',
}

const checkNonZeroValues = (str) => {
    const regex = /^(0*\.?0*)+$/;

    return regex.test(str);
}

export const formatPrice = (price, currencyCode) => {
    if(!price || (!isString(price) && !isNumber(price))) return

    const formattedPrice = toNumber(price).toFixed(2)
    const currencyMarkSymbol = currencyCode && CURRENCY_MARK[currencyCode]
    const currencyMark = currencyMarkSymbol ?? CURRENCY_MARK.USD
    const isPriceZero = checkNonZeroValues(formattedPrice)

    return formattedPrice && !isPriceZero ? `${currencyMark}${formattedPrice}` : undefined
}